// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAd7bC0JgF-ED9CqJFxc7ZRpr78cldx9Qc",
  authDomain: "croop-5935c.firebaseapp.com",
  projectId: "croop-5935c",
  storageBucket: "croop-5935c.firebasestorage.app",
  messagingSenderId: "641701015837",
  appId: "1:641701015837:web:b05dde23d986631e9931f4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore and Storage
export const db = getFirestore(app);
export const storage = getStorage(app);

// Add CORS configuration for localhost
if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
  // This helps with CORS issues during development
  console.log('Running on localhost - Firebase configured for development');
}

// Initialize Firebase Authentication
export const auth = getAuth(app);

export default app;